import { VStack } from 'native-base';
import { Empty } from 'antd';
import AppText from '../../../../../shared/components/common/AppText';
import CustomButtonV2 from '../../../../../shared/components/common/CustomButtonV2';
import AutoActionsEmptyImage from '../../../../../shared/assets/auto-actions-page-empty-state.png';
import { t } from '../../../../../shared/services/i18n';
import { Colors } from '../../../../../shared/styles/Colors';
import { GlobalStyleAttributes } from '../../../../../shared/styles/GlobalStyles';
import { AUTO_ACTION_CATEGORY } from '../AutoActionsConfig';

/** i18n keys per empty-state variant (`none` | `category` | `search` | `filters`). */
const EMPTY_STATE_MESSAGE_KEYS = {
    none: { titleKey: 'autoActionEmptyNoAutomations', descriptionKey: 'autoActionEmptyNoAutomationsDescription' },
    category: { titleKey: 'autoActionEmptyCategory', descriptionKey: 'autoActionEmptyCategoryDescription' },
    search: { titleKey: 'autoActionEmptySearch', descriptionKey: 'autoActionEmptySearchDescription' },
    filters: { titleKey: 'autoActionEmptyFilters', descriptionKey: 'autoActionEmptyFiltersDescription' },
};

const AutoActionsEmptyState = ({ variant, categoryId, actionLabelKey, onAction }) => {
    const messageKeys = EMPTY_STATE_MESSAGE_KEYS[variant] ?? EMPTY_STATE_MESSAGE_KEYS.search;

    const category = AUTO_ACTION_CATEGORY[categoryId];
    const categoryName = category && category !== AUTO_ACTION_CATEGORY.all ? t(category.name) : '';

    const title = t(messageKeys.titleKey, categoryName ? { category: categoryName } : undefined);
    const description = t(messageKeys.descriptionKey);

    return (
        <VStack alignItems="center" space="1rem" paddingY="3rem" width="100%">
            <Empty
                image={AutoActionsEmptyImage}
                description={
                    <VStack alignItems="center" space="6px">
                        <AppText
                            fontSize={GlobalStyleAttributes.fonts.heading18}
                            boldFont
                            style={{ textAlign: 'center', maxWidth: 420 }}
                        >
                            {title}
                        </AppText>
                        <AppText
                            fontSize={GlobalStyleAttributes.fonts.heading3}
                            color={Colors.newDesign.darkGrey}
                            style={{ textAlign: 'center', maxWidth: 420, lineHeight: '20px' }}
                        >
                            {description}
                        </AppText>
                    </VStack>
                }
            />
            {onAction && actionLabelKey && (
                <CustomButtonV2
                    type="link"
                    text={t(actionLabelKey)}
                    onClick={onAction}
                    iconProps={{ iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover }}
                    textProps={{ fontWeight: 600, color: Colors.newDesign.mainBlue }}/>
            )}
        </VStack>
    );
};

export default AutoActionsEmptyState;
